// Importaciones de React y React Router.
import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Para crear un enlace al formulario de consultas.

/**
 * Componente Faq (Preguntas Frecuentes).
 * Muestra una lista de preguntas que se pueden expandir y contraer (acordeón) para ver las respuestas.
 */
export const Faq = () => {
  // Estado para rastrear el índice de la pregunta actualmente abierta. `null` significa que ninguna está abierta.
  const [activeIndex, setActiveIndex] = useState(null);

  // Array de objetos que contiene las preguntas y respuestas.
  // Mantener los datos en esta estructura facilita la renderización y el mantenimiento.
  const faqs = [
    {
      question: '¿Pueden brindarme todas estas soluciones con un solo servicio?',
      answer: 'Totalmente, una vez identificados las soluciones que se ajusten a tu empresa y presupuesto, se entregan como un servicio que puede ser pagado mensual o anualmente.'
    },
    {
      question: '¿Pueden medir el retorno de la inversión?',
      answer: 'Así es, nuestros reportes mensuales les permiten identificar todos los casos detectados y contenidos y cual hubiese sido el impacto de no haberlo hecho.'
    },
    {
      question: '¿La evaluación inicial tiene costo?',
      answer: 'La evaluación es un servicio de valor agregado que nos permite entender mejor a tu empresa, así como demostrarles que nivel de riesgo están asumiendo, de esta manera, en conjunto trabajar en la reducción de estos riesgos.'
    },
  ];

  /**
   * Función para manejar el clic en una pregunta.
   * Si la pregunta clickeada ya está abierta, la cierra (estableciendo activeIndex a `null`).
   * Si está cerrada, la abre (estableciendo activeIndex al índice de esa pregunta).
   * @param {number} index - El índice de la pregunta en el array `faqs`.
   */
  const toggleFAQ = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    // Contenedor principal de la sección.
    <div className="bg-white p-4 md:p-8 flex justify-center min-h-screen">
      <div className="w-full max-w-4xl">
        
        {/* Cabecera de la sección. */}
        <div className="text-center mb-6 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-2 md:mb-4 text-black">PREGUNTAS FRECUENTES</h2>
          <p className="text-center mb-4 md:mb-8 text-xs md:text-base">Comunícate con nosotros si no puedes encontrar una respuesta a tu pregunta.</p>
        </div>

        {/* Contenedor de los elementos del acordeón. */}
        <div className="space-y-3 md:space-y-6">
          {/* Itera sobre el array `faqs` para renderizar cada pregunta y respuesta. */}
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg md:rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              {/* La cabecera de la pregunta (la parte clickeable). */}
              <div
                className={`p-3 md:p-6 cursor-pointer flex justify-between items-center transition-colors duration-300 ${
                  activeIndex === index ? 'bg-blue-600 text-white' : 'bg-blue-600 text-white hover:bg-blue-700'
                }`}
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="font-semibold text-xs md:text-lg pr-2 md:pr-4 leading-tight">{faq.question}</h3>
                {/* Icono de flecha que rota según si la pregunta está activa o no. */}
                <svg
                  className={`w-4 h-4 md:w-6 md:h-6 transform transition-transform duration-300 flex-shrink-0 ${
                    activeIndex === index ? 'rotate-180' : ''
                  }`}
                  fill="none" stroke="currentColor" viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              
              {/* El contenedor de la respuesta. */}
              {/* La clase `max-h-0` oculta el contenido, y `max-h-[500px]` lo muestra.
                  La transición en `max-h` crea el efecto de acordeón. */}
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  activeIndex === index ? 'max-h-[500px]' : 'max-h-0'
                }`}
              >
                <div className="p-3 md:p-6 bg-blue-100 text-black text-xs md:text-base leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Botón en la parte inferior que enlaza a la página de consultas. */}
        <div className="text-center mt-6 md:mt-12">
          <Link to={'/consultas'}>
            <button className="bg-blue-600 text-white py-2 md:py-3 px-4 md:px-8 rounded-lg shadow-md hover:bg-blue-700 transition-colors duration-300 transform hover:scale-105 text-xs md:text-base">
              Envíanos tu solicitud
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

// Exporta el componente para ser usado en otras páginas.
export default Faq;
